import { IBaseResponseData, ICongressionalRecord } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of Congressional Record responses from the
 * `/congressional-record` endpoint.
 */
export interface ICongressionalRecordResponse extends IBaseResponseData {
  Results: ICongressionalRecord[]
}
